import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOculus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconOculus"><Path fillRule="evenodd" clipRule="evenodd" d="M1.96392 8.53134C2.87346 6.46698 4.9131 5 7.32536 5H16.6748C19.087 5 21.1267 6.46698 22.0362 8.53134L22.7409 7.81438L23.8107 8.86583L22.5013 10.198C22.7737 12.0599 22.4698 14.134 21.578 15.8036C20.6103 17.6152 18.9117 19 16.5042 19H7.49599C5.08841 19 3.38982 17.6152 2.42212 15.8036C1.53031 14.134 1.22641 12.0599 1.49882 10.198L0.189453 8.86583L1.25924 7.81438L1.96392 8.53134ZM10 8V9.5H14V8H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOculus;
